// Angular libray
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

// Local library
import { AuthFacade } from '@amwager/authentication/data-access';
import { DepositPromoCodeService } from '@amwager/funding/data-access';
import { UnsubscribeObservableService,
TranslatePipe
} from '@amwager/util';

// Third party
import { Subscription, takeUntil } from 'rxjs';


@Component({
  selector: 'feature-mat-promo-code',
  templateUrl: './promo-code.component.html',
  styleUrls: ['./promo-code.component.scss'],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslatePipe
  ],
  standalone: true,
  providers: [DepositPromoCodeService],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PromoCodeComponent extends UnsubscribeObservableService implements OnInit {

  promoCodeForm!: FormGroup;

  // convenience getter for easy access to form fields
  get formVal() { return this.promoCodeForm?.controls }

  promoCode!: string;

  private subsPromoCodeResponse!: Subscription;

  isDepositing = false;

  isOnline: boolean = true;

  constructor(
    private readonly cdRef: ChangeDetectorRef,
    private readonly authFacade: AuthFacade,
    private readonly promoCodeService: DepositPromoCodeService,
  ) {
    super();

    // AuthFacade stays in the component: authentication/data-access already
    // depends on funding/data-access, so injecting it in the service would
    // create a circular dependency. The notification hide lives in the service.
    this.authFacade.isLogoutSuccess$().subscribe((isLogout?: boolean) => {
      if (isLogout) {
        this.promoCodeService.hideNotifications();
      }
    });
  }

  ngOnInit() {
    this.checkConnectivity();

    // OLD (moved to DepositPromoCodeService.buildForm):
    // this.initForm();
    this.promoCodeForm = this.promoCodeService.buildForm();

    this.formVal['promoCode']?.setValue('');
    this.promoCode = '';
  }

  promoCodeValue(): void {
    this.promoCode = this.formVal['promoCode']?.value;
  }

  deposit(): void {
    if (!this.isOnline) {
      // OLD (moved to DepositPromoCodeService.setOffline):
      // this.commonFacade.setIsConnectedInternet('PromoCodeComponent:deposit', false);
      this.promoCodeService.setOffline('PromoCodeComponent:deposit');
      return;
    }

    if (this.promoCodeForm.valid && this.promoCode) {
      this.isDepositing = true;

      // OLD (dispatch + success stream moved to DepositPromoCodeService.deposit$):
      // this.fundingFacade.depositPromoCode(this.promoCode);
      // this.subsPromoCodeResponse = this.fundingFacade.isDepositPromoCodeSuccess$()
      this.subsPromoCodeResponse = this.promoCodeService.deposit$(this.promoCode)
      .pipe(takeUntil(this.toUnsubscribe$))
      .subscribe(({response, isSuccess}) => {
        if (!isSuccess && response !== undefined) {
          const message = response.error.Error === 'User role not authorized for this action.' ?
            'You are not an Identified User.' : response.error.Message;
          this.showAlertMessage('Deposit Error', message);
          this.isDepositing = false;
          this.cdRef.markForCheck();
        }

        this.subsPromoCodeResponse?.unsubscribe();

        if (isSuccess) {
          this.showAlertMessage('Successful Deposit', 'Successfully Deposited Amount');
          this.promoCodeForm.reset();
          this.isDepositing = false;
          this.cdRef.markForCheck();
        }

      });
    }
    else {
      // OLD (moved to DepositPromoCodeService.markFormGroupTouched):
      // this.fundingService.markFormGroupTouched(this.promoCodeForm);
      this.promoCodeService.markFormGroupTouched(this.promoCodeForm);
    }
  }

  showAlertMessage(header: string, message: string): void {
    // OLD (moved to DepositPromoCodeService.showAlert):
    // this.matNotificationService.showAlert(header, message, undefined, undefined, 'Close');
    this.promoCodeService.showAlert(header, message);
  }

  checkConnectivity(): void {
    // OLD (moved to DepositPromoCodeService.checkConnectivity):
    // this.fundingService.checkConnectivity(
    //   this.environment,
    //   'PromoCodeComponent:checkConnectivity',
    //   (online: boolean) => this.isOnline = online
    // );
    this.promoCodeService.checkConnectivity(
      'PromoCodeComponent:checkConnectivity',
      (online: boolean) => this.isOnline = online
    );
  }

}
